import styled, { css } from 'styled-components';
import { shade } from 'polished';
import { DefaultColors } from '../../styles/global';

import { loadFromTransparent, bringFromLeft } from './animations';

import Button from '../../components/Button';
import Card from '../../components/Card';
import Input from '../../components/Input';

interface Test {
  load?: boolean;
}

interface StyledButtonProps {
  countdownOver?: boolean;
}

export const PageGame = styled.div`
  width: 100vw;
  height: 100vh;
  
  @media (max-width: 820px) {
    max-width: 300px;
  }
`;

export const TContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-left: 10em;
  position: relative;

  padding: 3px;

  animation: ${loadFromTransparent} 1.4s;

  @media (max-width: 820px) {
    margin: 0 auto;
  }
`;

export const PageWrapper = styled.div`
  display: flex;
`;

export const CircleContent = styled(Card)<Test>`
  width: 400px;
  height: 438px;

  display: flex;
  justify-content: flex-start;
  position: relative;

  margin-left: -12em;

  @media (max-width: 820px) {
    display: none;
  }

  ${(props) =>
    props.load
      ? css`
          animation: ${bringFromLeft} 1s;
        `
      : css`
          animation: ${bringFromLeft} 1s;
        `}

  .rccs__card > div {
    margin: 6px 0 0px 9px;
    height: 92%;
    width: 95%;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: auto;

  text-align: center;

  a {
    font-family: 'Poppins';
    text-decoration: none;
    color: #fff;

    transition: color 0.3s;

    &:hover {
      color: ${shade(0.4, '#fff')};
    }
  }

  .form {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;

  @media (max-width: 820px) {
    max-width: 300px;
    align-items: center;
  }
  }
`;

export const Content = styled.p`
  width: 440px;

  text-align: center;
  margin-top: 2em;

  font-family: 'Poppins';
  font-size: 18px;

  color: #fff;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  a {
    text-decoration: none;
  }

  @media (max-width: 700px) {
    padding: 0 32px;
  }
`;

export const StyledButton = styled(Button)<StyledButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 160px;
  height: 40px;
  border-radius: 220px;

  background: ${DefaultColors.secondColor};
  color: #fff;

  font-family: 'Poppins';
  font-size: 24px;
  align-self: flex-end;
  margin-right: 27px;

  @media (max-width: 820px) {
    margin: 0 auto;
    margin-top: 15px;
    align-self: center;
  }

  &:hover {
    background: ${shade(0.4, '#097D45')};
  }

  ${(props) =>
    props.countdownOver &&
    css`
      width: 100%;
    `}
`;

export const StyledInput = styled(Input)`
  width: 250px;
  height: 20px;
`;
